export interface SmartTagLimit {
  freeTags: number;
  freeReplacements: number;
}

export interface SmartTagOrderItem {
  size: SmartTagSize;
  colour: SmartTagColour;
  type: SmartTagType;
  orderType: SmartTagOrderType;
}

export interface SmartTagOrderRequest {
  intent: SmartTagOrderType;
  tags: SmartTagOrderItem[];
  source: SmartTagSource;
}

export interface SmartTagStripeRequest {
  $type: 'smartTag';
  priceIds: string[];
  tags: SmartTagOrderItem[];
  source: SmartTagSource;
}

export enum SmartTagColour {
  Indigo = 0, 
  PawPadPink = 1, 
  Biscuit = 2
}

export enum SmartTagSize {
  Small = 0,
  Medium = 1,
  Large = 2
}

export enum SmartTagType {
  Circular = 0,
  HookAndLoop = 1
}

export enum SmartTagSource {
  Unknown = 0,
  InApp = 1,
  Website = 2,
  Partner = 3,
  Admin = 4
}

export enum SmartTagOrderType {
  FreeNew = 0,
  FreeReplacement = 1,
  PurchaseNew = 2,
  PurchaseReplacement = 3
}
